import './App.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import routes from './routes/routes';

function App() {
  return (
    <div className="App">

      {routes()}

    </div>
  );
}

export default App;
